module.exports = __webpack_public_path__ + "img/KarlusMorales_Imagotype_Light.a2e3d76d.svg";